import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classes from './ReusableContentList.module.scss';

const ReusableContentList = (props) => {
  const { items = [] } = props;

  return (
    <div className={classes.container}>
      {items.map((item) => (
        <div className={classes.itemContainer}>
          {BuildChildren(item)}
        </div>
      ))}
    </div>
  );
};

ReusableContentList.propTypes = {
  items: PropTypes.array,
};

export default ReusableContentList;
